import { z } from 'zod'

export const OccupancyConfigFiltersSchema = z
    .object({
        truck: z.boolean(),
        motorcycle: z.boolean(),
        undetected_vehicle: z.boolean(),
        lpness: z.number(),
        lpr: z.number()
    })
    .strict()

export type OccupancyConfigFilters = z.infer<typeof OccupancyConfigFiltersSchema>

export const OccupancyConfigDataSchema = z
    .object({
        enabled: z.boolean().optional(),
        excluded_stations: z.array(z.string()),
        filters: OccupancyConfigFiltersSchema,
        lot_capacity_wl: z.number().int(),
        timeout: z.number().int(),
        timeout_wl: z.number().int(),
        version: z.literal('0.2.0')
    })
    .strict()

export type OccupancyConfigData = z.infer<typeof OccupancyConfigDataSchema>

export const GetOccupancyConfigVariablesSchema = z.object({
    parking_lot: z.string()
})

export type GetOccupancyConfigVariables = z.infer<typeof GetOccupancyConfigVariablesSchema>

export const UpdateOccupancyConfigVariablesSchema = z.object({
    parking_lot: z.string(),
    // Upstream codegen types this as `Scalars['json']` (i.e. `any`); kept loose to match.
    live_occupancy_config: z.any()
})

export type UpdateOccupancyConfigVariables = z.infer<typeof UpdateOccupancyConfigVariablesSchema>

export const GetOccupancyConfigQuerySchema = z.object({
    data: OccupancyConfigDataSchema
})

export type GetOccupancyConfigQuery = z.infer<typeof GetOccupancyConfigQuerySchema>

export const UpdateOccupancyConfigQuerySchema = z.object({
    message: z.string()
})

export type UpdateOccupancyConfigQuery = z.infer<typeof UpdateOccupancyConfigQuerySchema>
